/* eslint-disable perfectionist/sort-objects */
/* eslint-disable fp/no-mutation */
/* eslint-disable no-console */

type ConsoleType = 'error' | 'info' | 'log' | 'warn';

const ignoredMessages: Record<ConsoleType, string[]> = {
    error: [
        'fetchPriority', // not supported in react correctly, remove later
    ],
    info: [],
    log: [],
    warn: [
        'was preloaded using link preload but not used within a few seconds', // icon images are always preloaded
        'elastic-apm-node', // server only module, warning only happens in dev
        'Swiper Loop Warning',
        "A Map's preregistered map type may not apply all custom styles when a mapId is present",
        'Do not add <script> tags using next/head (see <script> tag with src="/google-tag-manager.js")', // does not work otherwise
    ],
};

const defaultConsole: Record<ConsoleType, typeof console.log> = {
    error: console.error,
    info: console.info,
    log: console.log,
    warn: console.warn,
};

const consoleOverride =
    (type: ConsoleType) =>
    (...args: unknown[]) => {
        if (includesIgnoredMessage(args, ...ignoredMessages[type])) {
            return;
        }
        defaultConsole[type](...args);
    };

console.log = consoleOverride('log');
console.info = consoleOverride('info');
console.warn = consoleOverride('warn');
console.error = consoleOverride('error');

/**
 *
 */
function includesIgnoredMessage(args: unknown[], ...ignoredMessages: string[]) {
    if (!Array.isArray(args)) {
        return false;
    }
    const message = args.join(' ');
    const isIgnored = ignoredMessages.some((ignoredMessage) => message.includes(ignoredMessage));

    return isIgnored;
}
